<template>
    <div
        class="d-flex align-items-center justify-content-between dropdown-item p-t-10 p-b-10 flex-wrap"
        :title="preset.name"
    >
        <span id="presetName" class="vue-preset-selector-preset-name" v-if="!patchPresetInit">{{
            preset.name | truncate
        }}</span>
        <form v-if="patchPresetInit">
            <input
                class="form-control"
                :placeholder="preset.name | truncate"
                id="patchPresetInput"
                v-model="updatePresetName"
                @change="$emit('change-preset-name', updatePresetName)"
            />
        </form>
        <div class="d-flex flex-wrap">
            <button class="btn btn-sm btn-success mr-1 my-2" @click.stop.prevent="$emit('select-preset', preset)">
                <i class="fa fa-chevron-right"></i>
                <span class="preset-btn-text">{{ 'Select' | trans }}</span>
            </button>
            <button
                class="btn btn-sm btn-info mr-1 my-2"
                @click.stop.prevent="
                    $emit('update-preset', preset);
                    initPatchPreset(preset);
                "
            >
                <i :class="{ 'fa fa-pen': !patchPresetInit, 'fa fa-arrow-left': patchPresetInit }"></i>
                <span class="preset-btn-text" v-if="!patchPresetInit">{{ 'Edit' | trans }}</span>
                <span class="preset-btn-text" v-else>{{ 'Back' | trans }}</span>
            </button>
            <button class="btn btn-sm btn-danger my-2" @click.stop.prevent="$emit('delete-preset', preset)">
                <i class="fa fa-trash"></i>
                <span class="preset-btn-text">{{ 'Delete' | trans }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { PresetApi } from '../../../../../lib-sat/api/preset-api';
import DataStatus from '../mixins/DataStatus';
import TransFilter from '../mixins/TransFilter';

const presetApi = new PresetApi();

export default {
    name: 'PresetItem',
    mixins: [DataStatus, TransFilter],
    props: {
        preset: Object,
    },
    mounted() {},
    filters: {
        truncate(str) {
            if (str.length < 50) {
                return str;
            }

            return `${str.substr(0, 50)}...`;
        },
    },
    methods: {
        initPatchPreset(preset) {
            if (this.patchPresetInit) {
                this.patchPresetInit = false;
                this.presetToUpdate = null;
            } else {
                this.patchPresetInit = true;
                this.presetToUpdate = preset;
            }
        },
    },
    data() {
        return {
            presetName: '',
            updatePresetName: '',
            presetSaved: false,
            patchPresetInit: false,
            presetToUpdate: null,
        };
    },
};
</script>

<style>
.vue-preset-selector-preset-name {
    text-indent: 0;
    width: 100%;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
